import React from "react";
import { Chip, LinearProgress, Tooltip, Typography } from "@mui/material";
import {
  formatarPercentualImportacao,
  resolverCelulaSituacaoImportacao,
} from "../../utils/importacoesExtrato.util";
import styles from "./styles.module.css";

export default function CelulaSituacaoImportacao({ row }) {
  const celula = resolverCelulaSituacaoImportacao(row);

  if (celula.modo === "progresso") {
    const pctLabel =
      celula.percentual != null
        ? formatarPercentualImportacao(celula.percentual)
        : "—";
    const conteudo = (
      <div className={styles.situacaoProgresso}>
        <div className={styles.situacaoProgressoLinha}>
          <LinearProgress
            variant={
              celula.percentual != null ? "determinate" : "indeterminate"
            }
            value={celula.percentual ?? 0}
            className={styles.situacaoBarra}
          />
          <Typography
            component="span"
            variant="caption"
            className={styles.situacaoPercentual}
          >
            {pctLabel}
          </Typography>
        </div>
        <Typography
          component="span"
          variant="caption"
          color="text.secondary"
          className={styles.situacaoEtapa}
        >
          {celula.etapa}
        </Typography>
      </div>
    );

    if (celula.tooltip) {
      return (
        <Tooltip title={celula.tooltip} placement="top">
          {conteudo}
        </Tooltip>
      );
    }
    return conteudo;
  }

  const chip = (
    <Chip
      size="small"
      label={celula.label}
      color={celula.chipColor || "default"}
    />
  );

  if (celula.tooltip) {
    return (
      <Tooltip title={celula.tooltip} placement="top">
        <span>{chip}</span>
      </Tooltip>
    );
  }
  return chip;
}
